<script lang="ts" setup>
import autoAnimate from '@formkit/auto-animate';
import { computed, onMounted, ref } from 'vue';
import { DeliveryWindow } from '../../utils/API/Delivery/deliveryAPISchema';
import * as CheckoutHelpers from '../../utils/checkoutHelpers';
import { getInitialVisibleWindowCount } from '../../utils/checkoutHelpers';
import { useDeliveryInformationStore } from './stores/deliveryInformationStore';

const props = defineProps<{
  deliveryWindows: DeliveryWindow[];
  selectedDeliveryWindow?: DeliveryWindow;
}>();

const deliveryInformationStore = useDeliveryInformationStore();

const INITIAL_AMOUNT_VISIBLE = 4;
const containerElement = ref();
const visibleWindowsAmount = ref(INITIAL_AMOUNT_VISIBLE);

const remainingHiddenWindows = computed(() => {
  return props.deliveryWindows.length > visibleWindowsAmount.value;
});

const visibleWindows = computed(() => {
  return props.deliveryWindows.slice(0, visibleWindowsAmount.value);
});

const handleLoadMoreClick = (e: Event) => {
  e.preventDefault();
  visibleWindowsAmount.value += INITIAL_AMOUNT_VISIBLE;
};

const handleDeliveryWindowClick = (deliveryWindow: DeliveryWindow) => {
  deliveryInformationStore.setSelectedDeliveryWindow(deliveryWindow);
};

onMounted(() => {
  autoAnimate(containerElement.value);

  if (!props.selectedDeliveryWindow) return;

  const initialCount = getInitialVisibleWindowCount(
    props.deliveryWindows,
    props.selectedDeliveryWindow,
    INITIAL_AMOUNT_VISIBLE
  );
  if (initialCount > visibleWindowsAmount.value) {
    visibleWindowsAmount.value = initialCount;
  }
});
</script>

<template>
  <div>
    <div ref="containerElement" class="checkout-delivery__windows">
      <label
        v-for="deliveryWindow in visibleWindows"
        :key="deliveryWindow.token"
        class="checkout-delivery__window"
        :for="deliveryWindow.token"
      >
        <input
          :id="deliveryWindow.token"
          type="radio"
          name="delivery-window"
          :checked="
            props.selectedDeliveryWindow?.start === deliveryWindow.start &&
            props.selectedDeliveryWindow?.end === deliveryWindow.end
          "
          :value="deliveryWindow.token"
          @click="handleDeliveryWindowClick(deliveryWindow)"
        />
        <div class="checkout-delivery__window-content">
          <div class="checkout-delivery__window-date">
            {{ CheckoutHelpers.formatDay(new Date(deliveryWindow.end)) }}
          </div>
          <div class="checkout-delivery__window-description">
            <div class="checkout-delivery__window-timestamp">
              {{ CheckoutHelpers.deliveryWindowTimeStamp(new Date(deliveryWindow.start)) }}-{{
                CheckoutHelpers.deliveryWindowTimeStamp(new Date(deliveryWindow.end))
              }}
            </div>
          </div>
        </div>
      </label>
    </div>
    <button
      v-if="remainingHiddenWindows"
      class="btn btn--link checkout-delivery__windows-loadmore"
      @click="handleLoadMoreClick"
    >
      {{ $t('seeMoreDeliveryWindows') }}
    </button>
  </div>
</template>
